// Frontend/src/unicodex_ui/services/portalAnalyticsApi.js
import api from "./apiClient";

function cleanParams(params = {}) {
  const out = {};
  Object.entries(params || {}).forEach(([k, v]) => {
    if (v === undefined || v === null) return;
    if (typeof v === "string" && v.trim() === "") return;
    out[k] = v;
  });
  return out;
}

const portalAnalyticsApi = {
  async runForecastJob(payload) {
    const res = await api.post("/api/analytics/forecast-jobs", payload);
    return res.data; // { ok, jobId, ... }
  },

  async listForecastResults(params = {}) {
    const res = await api.get("/api/analytics/forecast-results", { params: cleanParams(params) });
    return res.data; // { ok, jobId, rows }
  },
};

export default portalAnalyticsApi;
